import React, { useContext, useEffect, useState } from "react";
import AdminNav from "../Navbars/AdminNav";
import StudentNav from "../Navbars/StudentNav";
import GuestNav from "../Navbars/GuestNav";
import Footer from "../Footer";
import { UserContext } from "../UserContext";
import TeacherNav from "../Navbars/TeacherNav";
import "./MyProgress.css";
import { useNavigate, useParams } from "react-router-dom/dist/umd/react-router-dom.development";
import { Bell, Award, BarChart3, MessageSquare, Target, Coins } from "lucide-react";
import axios from "axios";
import Header from "../Header"
import pic1 from "../CourseImages/progress.png";
import certificateIcon from "../../assets/Student dashboard/Clip path group.png";
import activitiesIcon from "../../assets/Student dashboard/Group.png";
import remarksIcon from "../../assets/Student dashboard/Group 1686552592.png";
import projectIcon from "../../assets/Student dashboard/Group-1.png";
import pointsIcon from "../../assets/Student dashboard/Clip path group-1.png";

const MyProgress = () => {
  const {
    isAdmin,
    isTeacher,
    isStudent,
    isGuest,
    setUserRole,
    setUserInfo,
    userInfo,
  } = useContext(UserContext);

  const [studentId, setStudentId] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [averageMarksObtainedPercentage, setAverageMarksObtainedPercentage] = useState([]);
  const [averageProjectScorePercentage, setAverageProjectScorePercentage] = useState([]);
  const [totalPointsEarned, setTotalPointsEarned] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [notificationCount] = useState(3);
  const [isLoadingActivities, setIsLoadingActivities] = useState(false);
  const [isLoadingProject, setIsLoadingProject] = useState(false);
  const [isLoadingPoints, setIsLoadingPoints] = useState(false);

  const fullName =
    userInfo?.firstname && userInfo?.lastname
      ? `${userInfo.firstname} ${userInfo.lastname}`
      : userInfo?.username;

  const avatarInitials =
    userInfo?.firstname && userInfo?.lastname
      ? `${userInfo.firstname.charAt(0)}${userInfo.lastname.charAt(0)}`
      : userInfo?.username?.charAt(0)?.toUpperCase();

  const _avatar_ = userInfo?.avatar;
  const navigate = useNavigate();

  const { courseId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: "include",
      }).then((response) => {
        console.log("Response:", response);
        response
          .json()
          .then((userInfo) => {
            console.log("userinfo:", userInfo);
            setUserInfo(userInfo);

            if (userInfo?.usertype) {
              const uType = userInfo?.usertype;
              setUserRole(uType);
            }
            const user_id = userInfo.User_id;
            console.log("UserID: ", user_id);
            getStudentIdFromUser(user_id);
          })
          .catch((err) => console.log("Error in useeffect:", err));
      });
    };

    const getStudentIdFromUser = async (user_id) => {
      console.log("User id received is: ", user_id);
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentId/${user_id}`);
        if (response.data.success) {
          setStudentId(response.data.Student_id);
        } else {
          console.error(response.data.Message);
          setStudentId(null);
        }
      } catch (error) {
        console.error('Error fetching student ID:', error);
        setStudentId(null);
      }
    };
    setPdfUrl(null);
    fetchData();
  }, [isAdmin, isTeacher, isStudent, isGuest]);

  const determineUserRole = (usertype) => {
    console.log("In home.js:", usertype);
    if (usertype === "Student") return "Student";
    else if (usertype === "Teacher") return "Teacher";
    else if (usertype === "Admin") return "Admin";
    else return "guest";
  };

  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    setUserRole(userRole);
  };

  async function onLogout() {
    console.log("inside Onlogout.");
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    });
    setUserInfo(null);
    setUserRole("guest");
    navigate("/");
  }

  const calculateAverageScoreActivities = async (courseId, studentId) => {
    setIsLoadingActivities(true);
    try {
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getActivitiesAverageMarksObtained/${courseId}/${studentId}`
      );
      const _averageMarksObtainedPercentage = response.data.ActivitiesMetrics[0].AverageMarksPercentage;
      console.log("Average Marks Obtained Percentage: ", _averageMarksObtainedPercentage);
      setAverageMarksObtainedPercentage(_averageMarksObtainedPercentage);
    } catch (error) {
      console.log(error);
      setAverageMarksObtainedPercentage(0);
    } finally {
      setIsLoadingActivities(false);
    }
  };

  const calculateAverageScoreProject = async (courseId, studentId) => {
    setIsLoadingProject(true);
    try {
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getAverageProjectScore/${courseId}/${studentId}`
      );
      const combinedAverageMarksPercentage = response.data.CombinedAverageMarksPercentage;
      console.log("Average Project Score: ", combinedAverageMarksPercentage);
      setAverageProjectScorePercentage(combinedAverageMarksPercentage);
    } catch (error) {
      console.log(error);
      setAverageProjectScorePercentage(0);
    } finally {
      setIsLoadingProject(false);
    }
  };

  const calculatePointsEarned = async (courseId, studentId) => {
    setIsLoadingPoints(true);
    try {
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/courseMarks/${courseId}/${studentId}`
      );
      console.log("response: ", response.data);
      setTotalPointsEarned(response.data.TotalMarks);
    } catch (error) {
      console.log(error);
      setTotalPointsEarned(0);
    } finally {
      setIsLoadingPoints(false);
    }
  };

  const handlePDF = async (courseId, studentId) => {
    try {
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getCertificateFile/${studentId}/${courseId}`
      );
      console.log("PDF Certificate response: ", response);
      if (response?.data?.CertificateFile) {
        setPdfUrl(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/${response.data.CertificateFile}`);
      } else {
        setPdfUrl(null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRemarks = (courseId, studentId) => {
    // Placeholder for remarks logic
  };
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const userId = userInfo?.User_id;
        if (!userId) {
          return;
        }

        const response = await axios.get(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getCertificateCourses/${studentId}`
        );
        console.log("Enrolled courses response:", response.data);
        const fetchedCourses = response.data.courses || [];
        console.log("Fetched enrolled courses:", fetchedCourses);
        setCourses(fetchedCourses);

        // Get courseId from params, navigation state or default to first course
        const stateCourseId = location.state?.courseId;
        const defaultCourse = fetchedCourses.length > 0 ? fetchedCourses[0] : null;

        // Use param course ID if available, otherwise state course ID, otherwise default
        let initialCourseId = courseId;

        if (!initialCourseId) {
          initialCourseId = stateCourseId
            ? (fetchedCourses.find(c => String(c.Course_id) === String(stateCourseId))?.Course_id || defaultCourse?.Course_id)
            : defaultCourse?.Course_id;
        }

        const finalCourseId = initialCourseId || "";
        setSelectedCourse(finalCourseId);

        if (finalCourseId) {
          calculateAverageScoreActivities(finalCourseId, studentId);
          calculateAverageScoreProject(finalCourseId, studentId);
          calculatePointsEarned(finalCourseId, studentId);
          handlePDF(finalCourseId, studentId);
        }
      } catch (error) {
        console.error("Error fetching courses:", error.response?.data || error.message);
      }
    };

    setPdfUrl(null);
    if (studentId && userInfo?.User_id) {
      fetchCourses();
    } else {
      console.log("Student ID not set, skipping course fetch");
    }
  }, [studentId, userInfo?.User_id, courseId]);

  const handleCourseChange = (event) => {
    const selectedValue = event.target.value;
    console.log("selectedValue: ", selectedValue);
    console.log("courses: ", courses);
    setSelectedCourse(selectedValue);

    setAverageMarksObtainedPercentage(0);
    setAverageProjectScorePercentage(0);
    setTotalPointsEarned(0);
    setPdfUrl(null);

    setIsLoadingActivities(true);
    setIsLoadingProject(true);
    setIsLoadingPoints(true);

    calculateAverageScoreActivities(selectedValue, studentId);
    calculateAverageScoreProject(selectedValue, studentId);
    calculatePointsEarned(selectedValue, studentId);
    handlePDF(selectedValue, studentId);
  };

  return (
    <>
      {/* Navbar */}
      {fullName && (
        <>
          {isAdmin && <AdminNav username={fullName} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={fullName} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={fullName} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!fullName && <>{isGuest && <GuestNav onLogin={onLogin} />}</>}

      <div className="main-layout">
        <div className="progress-page">
          {/* Header */}
          {/* <div className="progress-header">
  <div className="progress-header-content">
    <div className="title-section">
      <h1 className="progress-title">Student Progress</h1>
    </div>
    <div className="user-section">
      <div className="notification-container">
        <div className="notification-icon">
          <Bell className="w-6 h-6" />
          {notificationCount > 0 && (
            <span className="notification-badge">{notificationCount}</span>
          )}
        </div>
      </div> */}
          {/* <div className="user-profile">
        <div className="user-avatar">
          <span>{avatarInitials}</span>
        </div>
        <div className="user-info">
          <span className="user-name">{fullName}</span>
        </div>
      </div>
    </div>
  </div>
</div> */}
          <Header title="My Progress" />

          <div className="progress-content">
            {/* Course Dropdown - Centered above progress cards */}
            {/* Course Dropdown - Centered above progress cards - Hide if courseId is in params */}
            {!courseId && (
              <select
                name="course"
                id="course"
                className="coursesOption"
                value={selectedCourse}
                onChange={handleCourseChange}
                style={{ zIndex: 1000, position: "relative", display: "inline-block" }}
              >
                {courses.length > 0 ? (
                  courses.map((course) => (
                    <option key={course.Course_id} value={course.Course_id}>
                      {course?.coursename}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    No courses available
                  </option>
                )}
              </select>
            )}
            <div className="course-title" style={{ textAlign: "center", marginBottom: "2rem" }}>

              <h2>
                {
                  selectedCourse
                    ? (courses.find((c) => String(c.Course_id) === String(selectedCourse))?.coursename || "No course selected")
                    : (courses.length > 0
                      ? (courses[0]?.coursename || "No course selected")
                      : "No course selected"
                    )
                }
              </h2>
            </div>

            {/* Progress Cards */}
            <div className="progress-cards-grid">
              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon certificate">
                    <img
                      src={certificateIcon || pic1}
                      alt="Certificate"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Certificate</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    {pdfUrl ? (
                      <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                        <span className="card-main-value">Available</span>
                        <span className="card-sub-value">Click to view</span>
                      </a>
                    ) : (
                      <span className="card-main-value">No</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon activities">
                    <img
                      src={activitiesIcon || pic1}
                      alt="Activities"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Avg. score Activities</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    {isLoadingActivities ? (
                      <span className="card-main-value" style={{ color: '#666', fontStyle: 'italic' }}>
                        Loading...
                      </span>
                    ) : (
                      <span className="card-main-value">{Math.round(averageMarksObtainedPercentage)}%</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon">
                    <img
                      src={remarksIcon || pic1}
                      alt="Remarks"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Remarks</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    <span className="card-main-value">Good</span>
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon project">
                    <img
                      src={projectIcon || pic1}
                      alt="Project"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Avg. score Project</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    {isLoadingProject ? (
                      <span className="card-main-value" style={{ color: '#666', fontStyle: 'italic' }}>
                        Loading...
                      </span>
                    ) : typeof averageProjectScorePercentage === "number" && !isNaN(averageProjectScorePercentage) ? (
                      <span className="card-main-value">{averageProjectScorePercentage.toFixed(1)}%</span>
                    ) : (
                      <>
                        <span className="card-main-value">—</span>
                        <span className="card-sub-value">No data</span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon points">
                    <img
                      src={pointsIcon || pic1}
                      alt="Points"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Points Earned</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    {isLoadingPoints ? (
                      <span className="card-main-value" style={{ color: '#666', fontStyle: 'italic' }}>
                        Loading...
                      </span>
                    ) : (
                      <span className="card-main-value">{totalPointsEarned}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MyProgress;